<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body position-relative">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- Tab general -->
                                    <CTab :title="$t('trigger')">
                                        <CContainer class="mt-4">
                                            <CRow class="mb-3">
                                                <CCol sm="12">
                                                    <h5>
                                                        {{
                                                            $t("set_an_trigger")
                                                        }}
                                                    </h5>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol md="9" sm="12">
                                                    <CInput
                                                        :label="$t('name')"
                                                        :placeholder="
                                                            $t('enter_the_name')
                                                        "
                                                        size="sm"
                                                        :invalidFeedback="
                                                            $t(
                                                                'name_is_required'
                                                            )
                                                        "
                                                        :horizontal="
                                                            default_horizontal
                                                        "
                                                        :isValid="
                                                            checkIfFormValid({
                                                                form_name:
                                                                    'trigger',
                                                                field_name:
                                                                    'name',
                                                            })
                                                        "
                                                        :value.sync="
                                                            $v.forms.trigger
                                                                .name.$model
                                                        "
                                                    />
                                                </CCol>
                                                <CCol md="3" sm="12">
                                                    <div
                                                        class="form-group form-row"
                                                    >
                                                        <label
                                                            class="col-form-label col-sm-3 col-form-label-sm"
                                                            >{{
                                                                $t("active")
                                                            }}</label
                                                        >
                                                        <div class="col-sm-9">
                                                            <CSwitch
                                                                :checked.sync="
                                                                    triggerActive
                                                                "
                                                                color="primary"
                                                                type="checkbox"
                                                                shape="pill"
                                                                variant="3d"
                                                                size="sm"
                                                            />
                                                        </div>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                            <CRow alignVertical="center">
                                                <CCol md="12" sm="12">
                                                    <h5>
                                                        {{
                                                            $t("trigger_events")
                                                        }}
                                                    </h5>
                                                    <p class="mb-1">
                                                        {{
                                                            $t(
                                                                "You can select one of the available trigger events"
                                                            )
                                                        }}
                                                    </p>
                                                    <SelectAsync
                                                        :placeholder="
                                                            $t('Search event')
                                                        "
                                                        size="sm"
                                                        :invalidFeedback="
                                                            $t(
                                                                'event_is_required'
                                                            )
                                                        "
                                                        :isValid="
                                                            checkIfFormValid({
                                                                form_name:
                                                                    'trigger',
                                                                field_name:
                                                                    'event_id',
                                                            })
                                                        "
                                                        :value.sync="
                                                            $v.forms.trigger
                                                                .event_id.$model
                                                        "
                                                        :formatOptions="
                                                            formatOptionsSelectAsyncById
                                                        "
                                                        endpoint="/trigger.api/getEvents"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol>
                                                    <EventExecuteConditionsManager
                                                        v-if="event"
                                                        :fieldsModel="
                                                            event.payload
                                                        "
                                                        :conditions="[
                                                            {
                                                                label: 'equal',
                                                                value: 'equal',
                                                            },
                                                        ]"
                                                        :value.sync="
                                                            forms.trigger
                                                                .event_execute_conditions
                                                        "
                                                    />
                                                </CCol>
                                            </CRow>
                                        </CContainer>
                                    </CTab>
                                    <CTab :title="$t('acceptance_filters')">
                                        <CContainer fluid class="mt-4">
                                            <CRow>
                                                <CCol>
                                                    <AcceptanceFiltersManager
                                                        v-if="event"
                                                        :fieldsModel="
                                                            event.payload
                                                        "
                                                        :value.sync="
                                                            forms.trigger
                                                                .acceptance_filters
                                                        "
                                                    />
                                                </CCol>
                                            </CRow>
                                        </CContainer>
                                    </CTab>
                                    <CTab :title="$t('action')">
                                        <CContainer class="mt-4">
                                            <CRow class="mb-3">
                                                <CCol sm="12">
                                                    <h5>
                                                        {{
                                                            $t(
                                                                "Choose integration & event"
                                                            )
                                                        }}
                                                    </h5>
                                                </CCol>
                                            </CRow>
                                            <CRow alignVertical="center">
                                                <CCol md="12" sm="12">
                                                    <h5>
                                                        {{ $t("integration") }}
                                                    </h5>
                                                    <p class="mb-1">
                                                        {{
                                                            $t(
                                                                "You need to select an integration to see the available actions"
                                                            )
                                                        }}.
                                                    </p>
                                                    <SelectAsync
                                                        :placeholder="
                                                            $t(
                                                                'select_an_integration'
                                                            )
                                                        "
                                                        size="sm"
                                                        :invalidFeedback="
                                                            $t(
                                                                'integration_is_required'
                                                            )
                                                        "
                                                        :isValid="
                                                            checkIfFormValid({
                                                                form_name:
                                                                    'trigger',
                                                                field_name:
                                                                    'plugin_marketing_credentials_uuid',
                                                            })
                                                        "
                                                        :value.sync="
                                                            $v.forms.trigger
                                                                .plugin_marketing_credentials_uuid
                                                                .$model
                                                        "
                                                        :optionsValue="'uuid'"
                                                        :optionsLabel="'name'"
                                                        endpoint='/connector.api/getPluginsCredentials?query=""'
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow
                                                alignVertical="center"
                                                v-if="
                                                    forms.trigger
                                                        .plugin_marketing_credentials_uuid
                                                "
                                            >
                                                <CCol>
                                                    <h5>
                                                        {{ $t("Action event") }}
                                                    </h5>
                                                </CCol>
                                                <CCol md="12" sm="12">
                                                    <CSelect
                                                        :options="
                                                            pluginActionsAsOptions
                                                        "
                                                        :value.sync="
                                                            $v.forms.trigger
                                                                .action_id
                                                                .$model
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'Select an action'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CAlert
                                                color="danger"
                                                v-if="!event"
                                                closeButton
                                            >
                                                {{
                                                    $t(
                                                        "you_must_select_an_event"
                                                    )
                                                }}
                                            </CAlert>
                                            <CCollapse
                                                :show="
                                                    !!pluginActionSelected &&
                                                    !!event
                                                "
                                            >
                                                <CContainer fluid>
                                                    <CRow>
                                                        <CCol>
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Set up action"
                                                                    )
                                                                }}
                                                            </h5>
                                                        </CCol>
                                                    </CRow>
                                                    <ZohoCreateLeadToContactActionSettings
                                                        v-if="
                                                            pluginActionSelected &&
                                                            pluginActionSelected.id ==
                                                                $options.consts
                                                                    .ZOHO_CREATE_LEAD_TO_CONTACT_ACTION_ID
                                                        "
                                                        :payload="event.payload"
                                                        :integration="{
                                                            uuid: forms.trigger
                                                                .plugin_marketing_credentials_uuid,
                                                        }"
                                                        :value.sync="
                                                            forms.trigger
                                                                .action_settings
                                                        "
                                                    />
                                                    
                                                    <HttpRequestMatchingResponseActionSettings
                                                        v-else-if="
                                                            pluginActionSelected &&
                                                            pluginActionSelected.id ==
                                                                $options.consts
                                                                    .HTTP_REQUEST_MATCHING_RESPONSE_ACTION_ID
                                                        "
                                                        :payload="event.payload"
                                                        :integration="{
                                                            uuid: forms.trigger
                                                                .plugin_marketing_credentials_uuid,
                                                        }"
                                                        :value.sync="
                                                            forms.trigger
                                                                .action_settings
                                                        "
                                                    />
                                                    <CRow
                                                        v-else
                                                        alignVertical="center"
                                                        v-for="(
                                                            item, index
                                                        ) in pluginActionFields"
                                                        :key="index"
                                                    >
                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-if="
                                                                item == 'lists'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t("Lists")
                                                                }}
                                                            </h5>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "You only have enabled the lists configured in the integration"
                                                                    )
                                                                }}.
                                                            </p>
                                                            <SelectAsync
                                                                :placeholder="
                                                                    $t(
                                                                        'search_list'
                                                                    )
                                                                "
                                                                size="sm"
                                                                :value.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .lists
                                                                "
                                                                optionsValue="id"
                                                                optionsLabel="name"
                                                                :endpoint="
                                                                    '/connector.api/getPluginConfigurationList/' +
                                                                    pluginIntegration.uuid
                                                                "
                                                                typeSelect="CSelect"
                                                            />
                                                        </CCol>
                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'fieldsMapping'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Fields mapping"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "You can map how you want the user to be sent to the integration. DataType are the fields that you have available, in leadgrease"
                                                                    )
                                                                }}.
                                                            </p>
                                                            <CDataTable
                                                                :items="
                                                                    tables
                                                                        .fieldsMapping
                                                                        .items
                                                                "
                                                                :fields="
                                                                    traslateLabels(
                                                                        tables
                                                                            .fieldsMapping
                                                                            .fields
                                                                    )
                                                                "
                                                                hover
                                                                border
                                                                striped
                                                            >
                                                                <template
                                                                    #no-items-view
                                                                >
                                                                    <div
                                                                        class="block-no-items section"
                                                                    >
                                                                        <h2
                                                                            class="section__title text-no-items"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "Add the fields to mapping"
                                                                                )
                                                                            }}
                                                                        </h2>
                                                                        <CButton
                                                                            color="success"
                                                                            class="button m-2 shadow"
                                                                            @click="
                                                                                addItemToTable(
                                                                                    'fieldsMapping'
                                                                                )
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="button__icon"
                                                                            >
                                                                                <CIcon
                                                                                    :content="
                                                                                        $options
                                                                                            .icons
                                                                                            .cilPlus
                                                                                    "
                                                                                />
                                                                            </span>
                                                                            <span
                                                                                class="button__text"
                                                                            >
                                                                                {{
                                                                                    $t(
                                                                                        "add_field"
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                        </CButton>
                                                                    </div>
                                                                </template>
                                                                <template
                                                                    #under-table
                                                                >
                                                                    <CButton
                                                                        color="success"
                                                                        class="button m-2 shadow"
                                                                        @click="
                                                                            addItemToTable(
                                                                                'fieldsMapping'
                                                                            )
                                                                        "
                                                                        v-if="
                                                                            tables
                                                                                .fieldsMapping
                                                                                .items
                                                                                .length >
                                                                            0
                                                                        "
                                                                    >
                                                                        <span
                                                                            class="button__icon"
                                                                        >
                                                                            <CIcon
                                                                                :content="
                                                                                    $options
                                                                                        .icons
                                                                                        .cilPlus
                                                                                "
                                                                            />
                                                                        </span>
                                                                        <span
                                                                            class="button__text"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "add_field"
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </CButton>
                                                                </template>
                                                                <template
                                                                    #dataType="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        <CSelect
                                                                            v-if="
                                                                                event
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    {
                                                                                        table_name:
                                                                                            'fieldsMapping',
                                                                                        index,
                                                                                        field_name:
                                                                                            'dataType',
                                                                                    }
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables
                                                                                    .fieldsMapping
                                                                                    .items
                                                                                    .$each
                                                                                    .$iter[
                                                                                    index
                                                                                ]
                                                                                    .dataType
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                event.payload
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_field'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </td>
                                                                </template>
                                                                <template
                                                                    #mappingName="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        <CInput
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    {
                                                                                        table_name:
                                                                                            'fieldsMapping',
                                                                                        index,
                                                                                        field_name:
                                                                                            'mappingName',
                                                                                    }
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables
                                                                                    .fieldsMapping
                                                                                    .items
                                                                                    .$each
                                                                                    .$iter[
                                                                                    index
                                                                                ]
                                                                                    .mappingName
                                                                                    .$model
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'enter_the_mapping'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </td>
                                                                </template>
                                                                <template
                                                                    #options="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td
                                                                        class="py-2 text-center"
                                                                    >
                                                                        <CButton
                                                                            color="danger"
                                                                            variant="outline"
                                                                            square
                                                                            size="sm"
                                                                            @click="
                                                                                deleteItemToTable(
                                                                                    'fieldsMapping',
                                                                                    index
                                                                                )
                                                                            "
                                                                        >
                                                                            <CIcon
                                                                                :content="
                                                                                    $options
                                                                                        .icons
                                                                                        .cilTrash
                                                                                "
                                                                            />
                                                                        </CButton>
                                                                    </td>
                                                                </template>
                                                            </CDataTable>
                                                        </CCol>
                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'fixedFields'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Fixed fields"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "You can create fixed fields for your integration"
                                                                    )
                                                                }}.
                                                            </p>
                                                            <TableFixedFields
                                                                :value.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .fixedFields
                                                                "
                                                            />
                                                        </CCol>
                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'emailType'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Email type"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-1">
                                                                {{
                                                                    $t(
                                                                        'Type of email this member asked to get ("html" or "text")'
                                                                    )
                                                                }}.
                                                            </p>
                                                            <CSelect
                                                                :placeholder="
                                                                    $t(
                                                                        'Email type'
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .emailType
                                                                "
                                                                size="sm"
                                                                :options="[
                                                                    {
                                                                        label: $t(
                                                                            'html'
                                                                        ),
                                                                        value: 'html',
                                                                    },
                                                                    {
                                                                        label: $t(
                                                                            'text'
                                                                        ),
                                                                        value: 'text',
                                                                    },
                                                                ]"
                                                            />
                                                        </CCol>

                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'updateEnabled'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Update enabled"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-1">
                                                                {{
                                                                    $t(
                                                                        "Facilitate to update the contact if already exist."
                                                                    )
                                                                }}.
                                                            </p>

                                                            <CSwitch
                                                                :checked.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .updateEnabled
                                                                "
                                                                color="primary"
                                                                name="action"
                                                                shape="pill"
                                                                variant="3d"
                                                                size="sm"
                                                            />
                                                        </CCol>

                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'useEmail'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Use email"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-1">
                                                                {{
                                                                    $t(
                                                                        "Send email to execute the action."
                                                                    )
                                                                }}.
                                                            </p>

                                                            <CSwitch
                                                                :checked.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .useEmail
                                                                "
                                                                color="primary"
                                                                name="action"
                                                                shape="pill"
                                                                variant="3d"
                                                                size="sm"
                                                            />
                                                        </CCol>

                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'usePhone'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Use phone"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-1">
                                                                {{
                                                                    $t(
                                                                        "Send phone to execute the action."
                                                                    )
                                                                }}.
                                                            </p>

                                                            <CSwitch
                                                                :checked.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings
                                                                        .usePhone
                                                                "
                                                                color="primary"
                                                                name="action"
                                                                shape="pill"
                                                                variant="3d"
                                                                size="sm"
                                                            />
                                                        </CCol>

                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else-if="
                                                                item ==
                                                                'mergeFields'
                                                            "
                                                        >
                                                            <h5>
                                                                {{
                                                                    $t(
                                                                        "Merge fields"
                                                                    )
                                                                }}
                                                            </h5>
                                                            <p class="mb-1">
                                                                {{
                                                                    $t(
                                                                        'A dictionary of merge fields (audience fields) where the keys are the merge tags. For example, {"FNAME":"Freddie"}'
                                                                    )
                                                                }}.
                                                            </p>
                                                            <CDataTable
                                                                :items="
                                                                    tables
                                                                        .mergeFields
                                                                        .items
                                                                "
                                                                :fields="
                                                                    traslateLabels(
                                                                        tables
                                                                            .mergeFields
                                                                            .fields
                                                                    )
                                                                "
                                                                hover
                                                                border
                                                                striped
                                                            >
                                                                <template
                                                                    #no-items-view
                                                                >
                                                                    <div
                                                                        class="block-no-items section"
                                                                    >
                                                                        <h2
                                                                            class="section__title text-no-items"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "Add merge field"
                                                                                )
                                                                            }}
                                                                        </h2>
                                                                        <CButton
                                                                            color="success"
                                                                            class="button m-2 shadow"
                                                                            @click="
                                                                                addItemToTable(
                                                                                    'mergeFields'
                                                                                )
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="button__icon"
                                                                            >
                                                                                <CIcon
                                                                                    :content="
                                                                                        $options
                                                                                            .icons
                                                                                            .cilPlus
                                                                                    "
                                                                                />
                                                                            </span>
                                                                            <span
                                                                                class="button__text"
                                                                            >
                                                                                {{
                                                                                    $t(
                                                                                        "add_field"
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                        </CButton>
                                                                    </div>
                                                                </template>
                                                                <template
                                                                    #under-table
                                                                >
                                                                    <CButton
                                                                        color="success"
                                                                        class="button m-2 shadow"
                                                                        @click="
                                                                            addItemToTable(
                                                                                'mergeFields'
                                                                            )
                                                                        "
                                                                        v-if="
                                                                            tables
                                                                                .mergeFields
                                                                                .items
                                                                                .length >
                                                                            0
                                                                        "
                                                                    >
                                                                        <span
                                                                            class="button__icon"
                                                                        >
                                                                            <CIcon
                                                                                :content="
                                                                                    $options
                                                                                        .icons
                                                                                        .cilPlus
                                                                                "
                                                                            />
                                                                        </span>
                                                                        <span
                                                                            class="button__text"
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "add_field"
                                                                                )
                                                                            }}
                                                                        </span>
                                                                    </CButton>
                                                                </template>
                                                                <template
                                                                    #dataType="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        <SelectFields
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    {
                                                                                        table_name:
                                                                                            'mergeFields',
                                                                                        index,
                                                                                        field_name:
                                                                                            'dataType',
                                                                                    }
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables
                                                                                    .mergeFields
                                                                                    .items
                                                                                    .$each
                                                                                    .$iter[
                                                                                    index
                                                                                ]
                                                                                    .dataType
                                                                                    .$model
                                                                            "
                                                                            :endpoint="'field'"
                                                                            :optionsValue="'name'"
                                                                            :optionsLabel="'name'"
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_field'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </td>
                                                                </template>
                                                                <template
                                                                    #audienceFiled="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        <CInput
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    {
                                                                                        table_name:
                                                                                            'mergeFields',
                                                                                        index,
                                                                                        field_name:
                                                                                            'audienceFiled',
                                                                                    }
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables
                                                                                    .mergeFields
                                                                                    .items
                                                                                    .$each
                                                                                    .$iter[
                                                                                    index
                                                                                ]
                                                                                    .audienceFiled
                                                                                    .$model
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'Enter audience filed'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </td>
                                                                </template>
                                                                <template
                                                                    #defaultValue="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td>
                                                                        <CInput
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    {
                                                                                        table_name:
                                                                                            'mergeFields',
                                                                                        index,
                                                                                        field_name:
                                                                                            'defaultValue',
                                                                                    }
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables
                                                                                    .mergeFields
                                                                                    .items
                                                                                    .$each
                                                                                    .$iter[
                                                                                    index
                                                                                ]
                                                                                    .defaultValue
                                                                                    .$model
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'Enter default value'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </td>
                                                                </template>
                                                                <template
                                                                    #options="{
                                                                        index,
                                                                    }"
                                                                >
                                                                    <td
                                                                        class="py-2 text-center"
                                                                    >
                                                                        <CButton
                                                                            color="danger"
                                                                            variant="outline"
                                                                            square
                                                                            size="sm"
                                                                            @click="
                                                                                deleteItemToTable(
                                                                                    'mergeFields',
                                                                                    index
                                                                                )
                                                                            "
                                                                        >
                                                                            <CIcon
                                                                                :content="
                                                                                    $options
                                                                                        .icons
                                                                                        .cilTrash
                                                                                "
                                                                            />
                                                                        </CButton>
                                                                    </td>
                                                                </template>
                                                            </CDataTable>
                                                        </CCol>
                                                        <CCol
                                                            md="12"
                                                            sm="12"
                                                            v-else
                                                        >
                                                            <CInput
                                                                :value.sync="
                                                                    forms
                                                                        .trigger
                                                                        .action_settings[
                                                                        item
                                                                    ]
                                                                "
                                                                :placeholder="
                                                                    item
                                                                "
                                                                :label="item"
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCollapse>
                                        </CContainer>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <CButton
                                    color="success"
                                    class="button shadow"
                                    @click="save()"
                                >
                                    <span class="button__icon text-white-50">
                                        <CIcon
                                            :content="$options.icons.cilSave"
                                        />
                                    </span>
                                    <span class="button__text">
                                        {{ $t("save") }}
                                    </span>
                                </CButton>
                                <!-- Button back -->
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import SelectAsync from "£lement/SelectAsync";
import SelectFields from "£lement/SelectFields";
import ButtonBack from "£lement/ButtonBack";
import EventExecuteConditionsManager from "~/pages/app/Services/Triggers/components/EventExecuteConditionsManager.vue";
import AcceptanceFiltersManager from "~/pages/app/Services/Triggers/components/AcceptanceFiltersManager.vue";
import TableFixedFields from "~/components/TableFixedFields.vue";
import ZohoCreateLeadToContactActionSettings from "~/pages/app/Services/Triggers/components/ZohoCreateLeadToContactActionSettings.vue";
import HttpRequestMatchingResponseActionSettings from "~/pages/app/Services/Triggers/components/HttpRequestMatchingResponseActionSettings.vue";
import CCTableAddItems from "~/components/CCTableAddItems";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import { validationMixin } from "vuelidate";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { ZOHO_CREATE_LEAD_TO_CONTACT_ACTION_ID, HTTP_REQUEST_MATCHING_RESPONSE_ACTION_ID } from "~/pages/app/Services/Triggers/Config/Types";
export default {
    name: "TriggerConfigPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin],
    consts: {
        ZOHO_CREATE_LEAD_TO_CONTACT_ACTION_ID,
        HTTP_REQUEST_MATCHING_RESPONSE_ACTION_ID,
    },
    components: {
        ButtonBack,
        SelectAsync,
        SelectFields,
        EventExecuteConditionsManager,
        AcceptanceFiltersManager,
        TableFixedFields,
        ZohoCreateLeadToContactActionSettings,
        HttpRequestMatchingResponseActionSettings,
        CCTableAddItems
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    data() {
        return {
            forms: {
                trigger: {
                    name: null,
                    action_id: null,
                    action_settings: null,
                    event_execute_conditions: [],
                    event_id: null,
                    active: true,
                    plugin_marketing_credentials_uuid: null,
                    acceptance_filters: [],
                    _loading: true,
                },
            },
            tables: {
                fieldsMapping: {
                    fields: [
                        {
                            key: "dataType",
                            label: "data_type",
                        },
                        {
                            key: "mappingName",
                            label: "mapping_name",
                        },
                        {
                            key: "options",
                            label: "options",
                        },
                    ],
                    items: [],
                },
                fixedFields: {
                    fields: [
                        {
                            key: "name",
                            label: "Field name",
                        },
                        {
                            key: "value",
                            label: "Field value",
                        },
                        {
                            key: "options",
                            label: "options",
                        },
                    ],
                    items: [],
                },
                mergeFields: {
                    fields: [
                        {
                            key: "dataType",
                            label: "Data type",
                        },
                        {
                            key: "audienceFiled",
                            label: "Audience filed",
                        },
                        {
                            key: "defaultValue",
                            label: "Default value",
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
            },
            selectedList: null,
            database: null,
            integration: null,
            action: null,
            // pluginConfigurationAssocLists:[]
        };
    },
    watch: {
        "tables.fieldsMapping.items": {
            handler: function (newValue, oldValue) {
                this.forms.trigger.action_settings = {
                    ...this.forms.trigger.action_settings,
                    fieldsMapping: newValue,
                };
            },
            deep: true,
        },
        "tables.mergeFields.items": {
            handler: function (newValue, oldValue) {
                this.forms.trigger.action_settings = {
                    ...this.forms.trigger.action_settings,
                    mergeFields: newValue,
                };
            },
            deep: true,
        },
        "tables.fixedFields.items": {
            handler: function (newValue, oldValue) {
                this.forms.trigger.action_settings = {
                    ...this.forms.trigger.action_settings,
                    fixedFields: newValue,
                };
            },
            deep: true,
        },
        // 'forms.trigger.plugin_marketing_credentials_uuid':async function (newValue, oldValue) {
        //     await this.loadPluginConfigurationAssocLists(newValue);
        // },
        event(newValue) {
            if (!this.forms.trigger.event_execute_conditions) {
                this.forms.trigger.event_execute_conditions = {};
                /* for (let i = 0; i < newValue.executeConditions.length; i++) {
                    const element = newValue.executeConditions[i];
                    this.forms.trigger.event_execute_conditions = {
                        ...this.forms.trigger.event_execute_conditions,
                        [element]: null,
                    };
                } */
            }
        },
        pluginActionSelected(newValue) {
            if (!this.forms.trigger.action_settings) {
                this.forms.trigger.action_settings = {};
            }
            if (newValue && !this.forms.trigger.action_settings) {
                for (let i = 0; i < newValue.fields.length; i++) {
                    const element = newValue.fields[i];
                    this.forms.trigger.action_settings = {
                        ...this.forms.trigger.action_settings,
                        [element]: element == "domain" ? null : [],
                    };
                }
            }
        },
    },
    validations: {
        forms: {
            trigger: {
                name: { required },
                event_id: {
                    required,
                },
                event_execute_conditions: {
                    required,
                },
                action_id: {
                    required,
                },
                action_settings: {
                    required,
                },
                plugin_marketing_credentials_uuid: { required },
                active: { required },
            },
        },
        tables: {
            fieldsMapping: {
                items: {
                    $each: {
                        dataType: {
                            required,
                        },
                        mappingName: {},
                        defaultValue: {},
                    },
                },
            },
            fixedFields: {
                items: {
                    $each: {
                        name: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            mergeFields: {
                items: {
                    $each: {
                        dataType: {
                            required,
                        },
                        audienceFiled: {
                            required,
                        },
                        defaultValue: {},
                    },
                },
            },
        },
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
            storeTriggerPlugins: "global/triggerPlugins",
            storePluginIntegrations: "global/pluginIntegrations",
            storeTriggerEvents: "global/triggerEvents",
        }),

        event() {
            return this.storeTriggerEvents.find(
                (event) => event.id == this.forms.trigger.event_id
            );
        },

        triggerActive: {
            set(newValue) {
                this.$v.forms.trigger.active.$model = newValue;
            },
            get() {
                return this.stringToBoolean(
                    this.$v.forms.trigger.active.$model
                );
            },
        },

        pluginIntegration() {
            let find = this.storePluginIntegrations.find(
                (pluginIntegration) =>
                    pluginIntegration.uuid ==
                    this.forms.trigger.plugin_marketing_credentials_uuid
            );
            return find;
        },
        plugin() {
            return this.storeTriggerPlugins.find(
                (plugin) => plugin.uuid == this.pluginIntegration.driver_id
            );
        },
        pluginActionsAsOptions() {
            if (this.plugin) {
                return this.plugin.actions.map((action) => {
                    return {
                        value: action.id,
                        label: action.name,
                    };
                });
            }
            return [];
        },
        pluginActionSelected() {
            if (this.forms.trigger.action_id && this.plugin) {
                let find = this.plugin.actions.find((action) => {
                    return this.forms.trigger.action_id == action.id;
                });
                return find;
            }
            return null;
        },
        pluginActionFields() {
            if (this.pluginActionSelected) {
                return this.pluginActionSelected.fields;
            }
            return [];
        },
        view_type: function () {
            return this.routeName.includes("edit") ? "edit" : "create";
        },
        uuid: function () {
            return this.$route.query.uuid;
        },
    },
    methods: {
        async save() {
            this.updatePageLoading(true);
            try {
                let { status } = await this.sendForm({
                    form_name: "trigger",
                    url: "/trigger.api/triggerConfiguration",
                    url_param: this.uuid,
                });
                if (status == true) {
                    this.$router.push({ name: "triggers" });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
        async eventValidateForm(formName) {
            let isValid = true;
            let formValidation = formName
                ? this.$v.forms[formName]
                : this.$v.form;
            formValidation.$touch();

            let fieldsMappingValidation = this.$v.tables["fieldsMapping"];
            fieldsMappingValidation.$touch();
            if (fieldsMappingValidation.$invalid) {
                this.showMessageError("invalid_data");
                isValid = false;
            }

            if (formValidation.$invalid) {
                this.showMessageError("invalid_data");
                isValid = false;
            }
            return isValid;
        },

        async formParseData({ data }) {
            let parseData = {
                ...data._items,
            };
            if (parseData.action_settings)
                parseData.action_settings = JSON.parse(
                    parseData.action_settings
                );
            if (parseData.event_execute_conditions)
                parseData.event_execute_conditions = JSON.parse(
                    parseData.event_execute_conditions
                );
            if (parseData.acceptance_filters)
                parseData.acceptance_filters = JSON.parse(
                    parseData.acceptance_filters
                );
            return parseData;
        },

        formatOptionsSelectAsyncById(data) {
            let formatData = data._items.map((item) => {
                return {
                    text: item.name,
                    value: item.id,
                };
            });

            return formatData;
        },
        formatOptionsSelectAsyncByUuid(data) {
            let formatData = data._items.map((item) => {
                return {
                    text: item.name,
                    value: item.uuid,
                };
            });

            return formatData;
        },
        // formatOptionsSelectAsyncToPluginsConfigurationAssocList(data){
        //     let formatData =  data._items.map(item => {
        //         return {
        //             text:item.list_name,
        //             value:item.uuid
        //         };
        //     });

        //     return formatData;
        // },

        async loadTriggerPlugins() {
            if (this.storeTriggerPlugins.length == 0) {
                let plugins = await this.fetcher({
                    url: "/trigger.api/plugins",
                });

                this.$store.dispatch("global/saveTriggerPlugins", {
                    triggerPlugins: plugins._items,
                });
            }
        },
        async loadTriggerEvents() {
            if (this.storeTriggerEvents.length == 0) {
                let triggerEvents = await this.fetcher({
                    url: "/trigger.api/getEvents",
                });
                this.$store.dispatch("global/saveTriggerEvents", {
                    triggerEvents: triggerEvents._items,
                });
            }
        },

        async loadPluginIntegrations() {
            if (this.storePluginIntegrations.length == 0) {
                let pluginIntegrations = await this.fetcher({
                    url: '/connector.api/getPluginsCredentials?query=""',
                });

                this.$store.dispatch("global/savePluginIntegrations", {
                    pluginIntegrations: pluginIntegrations._items,
                });
            }
        },
        // async loadPluginConfigurationAssocLists(plugin_marketing_credentials_uuid){
        //     if(plugin_marketing_credentials_uuid){
        //         let lists = await this.fetcher({
        //             url:'/connector.api/getPluginConfigurationList/'+ plugin_marketing_credentials_uuid
        //         });
        //         this.pluginConfigurationAssocLists = lists._items.map(item => {
        //             return {
        //                 name:item.name,
        //                 value:item.id
        //             }
        //         });
        //     }
        // },

        async eventAfterLoadForm(form) {
            if (form.action_settings.fieldsMapping)
                this.tables.fieldsMapping.items =
                    form.action_settings.fieldsMapping;
            if (form.action_settings.mergeFields)
                this.tables.mergeFields.items =
                    form.action_settings.mergeFields;
            if (form.action_settings.fixedFields)
                this.tables.fixedFields.items =
                    form.action_settings.fixedFields;
            return form;
        },

        async eventBeforeSendForm(form) {
            let actionSettings = {};
            for (
                let index = 0;
                index < this.pluginActionFields.length;
                index++
            ) {
                const actionField = this.pluginActionFields[index];
                actionSettings = {
                    ...actionSettings,
                    [actionField]: form.action_settings[actionField],
                };
            }
            form.action_settings = actionSettings;
            return form;
        },

        getDefaultTableItem(tableName) {
            let item = {};
            this.tables[tableName].fields.forEach((field) => {
                if (field.key != "options")
                    item = {
                        ...item,
                        [field.key]: null,
                    };
            });
            return item;
        },

        addItemToTable(tableName) {
            let defaultItem = this.getDefaultTableItem(tableName);
            let items = [...this.tables[tableName].items];
            items.push(defaultItem);
            // this.tables[tableName].items.push(defaultItem);
            this.$set(this.tables[tableName], "items", items);
            // this.tables[tableName].items.push(defaultItem);
        },
        deleteItemToTable(tableName, index) {
            this.tables[tableName].items.splice(index, 1);
        },
    },
    async mounted() {
        await this.loadTriggerPlugins();
        await this.loadTriggerEvents();
        await this.loadPluginIntegrations();
        if (this.routeName.includes("edit")) {
            await this.updateForm({
                form_name: "trigger",
                url: "/trigger.api/triggerConfiguration/" + this.uuid,
            });
            // await this.loadPluginConfigurationAssocLists(this.forms.trigger.plugin_marketing_credentials_uuid);
        } else {
            this.forms.trigger._loading = false;
        }
        this.updatePageLoading(false);
    },
};
</script>
<style lang="scss" scoped>
.plugin {
    & .img_plugin {
        height: 5em;
        width: auto;
    }
}
</style>
